import { html, type TemplateResult } from 'lit';

import { dataViewI18nT } from '../../../core/i18n.js';
import type { GanttSnapMode } from '../define.js';
import type { SettingsSection } from '../extensions/index.js';
import type { GanttSingleView } from '../gantt-view-manager.js';

const SNAP_MODES: readonly GanttSnapMode[] = ['day', 'week', 'none'];

/**
 * Default settings section that surfaces the snap-mode selector. Third
 * parties can register additional sections against
 * `view.extensions.settingsSections` without replacing this one.
 */
export class GanttSnappingSettingsSection implements SettingsSection {
  readonly id = 'streamlain.gantt.settings.snapping';
  readonly priority = 10;
  readonly labelKey = 'com.streamlain.gantt.settings.section.snapping';

  render(view: GanttSingleView): TemplateResult {
    const current = view.snapMode$.value;
    const onChange = (evt: Event) => {
      const target = evt.target as HTMLSelectElement;
      const next = target.value as GanttSnapMode;
      if (SNAP_MODES.includes(next)) {
        view.setSnapMode(next);
      }
    };
    return html`
      <label>
        <span>${dataViewI18nT('gantt.settings.snap')}</span>
        <select .value=${current} @change=${onChange}>
          <option value="day">${dataViewI18nT('gantt.snap.day')}</option>
          <option value="week">${dataViewI18nT('gantt.snap.week')}</option>
          <option value="none">${dataViewI18nT('gantt.snap.none')}</option>
        </select>
      </label>
    `;
  }
}
